import React from "react";
import { ManualInvoiceDetails } from "../Invoice/ManualInvoiceDetails";
import ScanEditWithSaveButton from "../Scan/ScanEditWithSaveButton";
import { MemorizedEditableManualReceiveLineItemTable } from "../Invoice/ManualReceiveLineItemTable";
import { Grid2 as Grid } from "@mui/material";
import { LocationBay } from "../Common/LocationBay/LocationBay";
import CurrentLocationBayAlert from "../CurrentLocationBayAlert";
import { PurchaseOrderReceiveLineItem } from "../../common/PurchaseOrderLineItem";
import { ManualReceiveEditProps } from "./types";
import { useStyles } from "./Receive.styles";

export const ManualReceiveEdit: React.FC<ManualReceiveEditProps> = ({
	receive,
	storeName,
	editableInvoiceFields,
	handleInvoiceFieldChanged,
	onExpandInvoiceClick,
	onReceivedQuantityChange,
	isInvoiceExpanded,
	isHardwareView,
	currentScannedProduct,
	onDataChange,
	onSaveItemClick,
	onCostChange,
	validateInvoiceNumber,
	onLocationNameChange,
	currentLocation,
	locationBays,
	enableAssignIbLocation,
	priorityStock,
	isArrivalsFeatureEnabled,
	isPriorityStockEnabled,
	asns,
	isModalAsnDetailsOpen,
	onAsnDetailsModalOpen,
	onAsnDetailsModalClose,
	captureFreightCostEnabled,
}) => {
	const classes = useStyles();
	const mapReceiveLineItemsByLocationBay = (
		locationName: string,
		lineItems: PurchaseOrderReceiveLineItem[]
	): PurchaseOrderReceiveLineItem[] => {
		return lineItems.filter((rli) => {
			return rli.inboundLocation === locationName;
		});
	};
	return (
		<Grid container className={classes.manualReceiveEditContainer}>
			<Grid container direction="column" size="grow">
				<ManualInvoiceDetails
					receive={receive}
					storeName={storeName}
					showInvoiceDetails={isInvoiceExpanded}
					onExpandClick={onExpandInvoiceClick}
					validateInvoiceNumber={validateInvoiceNumber}
					editableInvoiceFields={editableInvoiceFields}
					handleInvoiceFieldChanged={handleInvoiceFieldChanged}
					asns={asns}
					isModalAsnDetailsOpen={isModalAsnDetailsOpen}
					onAsnDetailsModalOpen={onAsnDetailsModalOpen}
					onAsnDetailsModalClose={onAsnDetailsModalClose}
					captureFreightCostEnabled={captureFreightCostEnabled}
				/>
				<ScanEditWithSaveButton
					productId={currentScannedProduct.productId}
					productQty={currentScannedProduct.qty}
					onDataChange={onDataChange}
					onSaveItemClick={onSaveItemClick}
					enableAssignIbLocation={enableAssignIbLocation}
				/>

				{(!enableAssignIbLocation || locationBays.length === 0) && (
					<MemorizedEditableManualReceiveLineItemTable
						invoiceNumber={receive?.invoiceNumber ?? ""}
						lineItems={receive?.receiveLineItems ?? []}
						isHardwareView={isHardwareView}
						isLocationBayEditable={false}
						showDetailsOnly={false}
						onReceivedQuantityChange={onReceivedQuantityChange}
						onCostChange={onCostChange}
						showOverReceive={true}
						onLocationNameChange={onLocationNameChange}
						priorityStock={priorityStock}
						isArrivalsFeatureEnabled={isArrivalsFeatureEnabled}
						isPriorityStockEnabled={isPriorityStockEnabled}
					/>
				)}
				{enableAssignIbLocation && (locationBays.length > 0 || currentLocation) && (
					<>
						<CurrentLocationBayAlert currentLocation={currentLocation} />

						{locationBays.map((locationBay, idx) => {
							const lineItems = mapReceiveLineItemsByLocationBay(locationBay, receive?.receiveLineItems ?? []);
							return (
								<React.Fragment key={idx}>
									<LocationBay
										locationName={locationBay}
										onLocationNameChange={onLocationNameChange}
										key={idx}
										hasLineItems={lineItems.length > 0}
									>
										<MemorizedEditableManualReceiveLineItemTable
											invoiceNumber={receive?.invoiceNumber ?? ""}
											lineItems={lineItems}
											isHardwareView={isHardwareView}
											isLocationBayEditable={true}
											showDetailsOnly={false}
											onReceivedQuantityChange={onReceivedQuantityChange}
											onCostChange={onCostChange}
											showOverReceive={true}
											onLocationNameChange={onLocationNameChange}
											priorityStock={priorityStock}
											isArrivalsFeatureEnabled={isArrivalsFeatureEnabled}
											isPriorityStockEnabled={isPriorityStockEnabled}
										/>
									</LocationBay>
								</React.Fragment>
							);
						})}
					</>
				)}
			</Grid>
		</Grid>
	);
};

export const MemorizedManualReceiveEdit = React.memo(ManualReceiveEdit);
